import React from 'react'
import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { FoodRestriction } from '@/api/types'
import { Tag, TagGroup } from '@/components/TagGroup'

type Props = {
  allergens: FoodRestriction[]
  selectedAllergens?: string[]
  isDisabled?: boolean
  onChange?: (tags: string[]) => void
}

export default function AllergensEditor({
  allergens,
  selectedAllergens,
  isDisabled,
  onChange,
}: Props) {
  const { t } = useTranslation()

  return (
    <TagGroup
      label={t('recipe.allergens')}
      selectionMode="multiple"
      items={allergens}
      disallowEmptySelection
      disabledKeys={isDisabled ? allergens.map((a) => a.name) : []}
      selectedKeys={selectedAllergens || []}
      onSelectionChange={(selection: Set<string>) => onChange && onChange([...selection])}>
      {(item) => <Tag id={item.name}>{item.name}</Tag>}
    </TagGroup>
  )
}
